<template>
    <v-dialog :value="true" width="1000" scrollable>
        <v-card class="user-avatar-builder">
            <v-card-title class="headline">
                Upravit Avatar
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="16">
                        <v-tabs :show-arrows="false" >
                            <v-tab>Barva těla</v-tab>
                            <v-tab>Barva trička</v-tab>
                            <v-tab>Barva pozadí</v-tab>
                            <v-tab>Oči</v-tab>
                            <v-tab>Ústa</v-tab>
                            <v-tab>Barva úst</v-tab>
                            <v-tab>Vlasy</v-tab>
                            <v-tab>Barva vlasů</v-tab>

                            <v-tab-item>
                                <v-row>
                                    <v-col cols="16" sm="8" class="d-flex justify-center align-center">
                                        <user-avatar-view :settings="settings" />
                                    </v-col>
                                    <v-col cols="16" sm="8">
                                        <p>Barva těla</p>
                                        <v-color-picker
                                            :hide-canvas="false"
                                            :hide-inputs="true"
                                            :hide-mode-switch="true"
                                            :show-swatches="false"
                                            mode="rgba"
                                            v-model="skinColor"
                                        />
                                    </v-col>
                                </v-row>

                            </v-tab-item>

                            <v-tab-item>
                                <v-row>
                                    <v-col cols="16" sm="8" class="d-flex justify-center align-center">
                                        <user-avatar-view :settings="settings" />
                                    </v-col>
                                    <v-col cols="16" sm="8">
                                        <p>Barva trička</p>
                                        <v-color-picker
                                            :hide-canvas="false"
                                            :hide-inputs="true"
                                            :hide-mode-switch="true"
                                            :show-swatches="false"
                                            mode="rgba"
                                            v-model="clothColor"
                                        />
                                    </v-col>
                                </v-row>

                            </v-tab-item>

                            <v-tab-item>
                                <v-row>
                                    <v-col cols="16" sm="8" class="d-flex justify-center align-center">
                                        <user-avatar-view :settings="settings" />
                                    </v-col>
                                    <v-col cols="16" sm="8">
                                        <p>Barva pozadí</p>
                                        <v-color-picker
                                            :hide-canvas="false"
                                            :hide-inputs="true"
                                            :hide-mode-switch="true"
                                            :show-swatches="false"
                                            mode="rgba"
                                            v-model="backgroundColor"
                                        />
                                    </v-col>
                                </v-row>

                            </v-tab-item>

                            <v-tab-item>
                                <v-row>
                                    <v-col cols="16" sm="8" class="d-flex justify-center align-center">
                                        <user-avatar-view :settings="settings" />
                                    </v-col>
                                    <v-col cols="16" sm="8" class="blazon">
                                        <p>Oči</p>

                                        <div class="blazon__boxes">
                                            <div class="blazon__box" v-for="eye in eyes" :key="eye">
                                                <div class="blazon__content">
                                                    <eyes-loader @click.native="onSelectEyes(eye)" :eyes="eye" :settings="settings" :is-preview="true" />
                                                </div>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>

                            </v-tab-item>

                            <v-tab-item>
                                <v-row>
                                    <v-col cols="16" sm="8" class="d-flex justify-center align-center">
                                        <user-avatar-view :settings="settings" />
                                    </v-col>
                                    <v-col cols="16" sm="8" class="blazon">
                                        <p>Ústa</p>

                                        <div class="blazon__boxes">
                                            <div class="blazon__box" v-for="mouth in mouths" :key="mouth">
                                                <div class="blazon__content">
                                                    <mouths-loader @click.native="onSelectMouth(mouth)" :mouth="mouth" :settings="settings" :is-preview="true" />
                                                </div>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>

                            </v-tab-item>

                            <v-tab-item>
                                <v-row>
                                    <v-col cols="16" sm="8" class="d-flex justify-center align-center">
                                        <user-avatar-view :settings="settings" />
                                    </v-col>
                                    <v-col cols="16" sm="8">
                                        <p>Barva úst</p>
                                        <v-color-picker
                                            :hide-canvas="false"
                                            :hide-inputs="true"
                                            :hide-mode-switch="true"
                                            :show-swatches="false"
                                            mode="rgba"
                                            v-model="mouthColor"
                                        />
                                    </v-col>
                                </v-row>

                            </v-tab-item>

                            <v-tab-item>
                                <v-row>
                                    <v-col cols="16" sm="8" class="d-flex justify-center align-center">
                                        <user-avatar-view :settings="settings" />
                                    </v-col>
                                    <v-col cols="16" sm="8" class="blazon">
                                        <p>Vlasy</p>

                                        <div class="blazon__boxes">
                                            <div class="blazon__box" v-for="item in hair" :key="item">
                                                <div class="blazon__content">
                                                    <hair-loader @click.native="onSelectHair(item)" :hair="item" :settings="settings" :is-preview="true" />
                                                </div>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>

                            </v-tab-item>

                            <v-tab-item>
                                <v-row>
                                    <v-col cols="16" sm="8" class="d-flex justify-center align-center">
                                        <user-avatar-view :settings="settings" />
                                    </v-col>
                                    <v-col cols="16" sm="8">
                                        <p>Barva vlasů</p>
                                        <v-color-picker
                                            :hide-canvas="false"
                                            :hide-inputs="true"
                                            :hide-mode-switch="true"
                                            :show-swatches="false"
                                            mode="rgba"
                                            v-model="hairColor"
                                        />
                                    </v-col>
                                </v-row>

                            </v-tab-item>
                        </v-tabs>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-divider/>
            <v-card-actions>
                <v-btn color="secondary" text @click.stop="onClose">Zrušit</v-btn>
                <v-spacer/>
                <v-btn color="primary" dark :loading="saving" :disabled="saving" @click.stop="onSave">Uložit</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import { eyes, hair, mouths } from '../UserAvatar/index';
    import EyesLoader from '../UserAvatar/Eyes/EyesLoader';
    import UserAvatarView from '../UserAvatar/UserAvatarView';
    import HairLoader from '../UserAvatar/Hair/HairLoader';
    import MouthsLoader from '../UserAvatar/Mouths/MouthsLoader';
    import { UPDATE_PROFILE_REQUEST } from '../../store/actions/user';

    export default {
        name: 'UserAvatarBuilder',
        components: {
            MouthsLoader,
            HairLoader,
            UserAvatarView,
            EyesLoader,
        },
        props: {
            currentAvatar: {
                type: Object,
                required: true,
            },
        },
        data () {
            return {
                saving: false,
                eyes,
                hair,
                mouths,
                selectedHair: 'Hair1',
                selectedEyes: 'Eye1',
                selectedMouth: 'Mouth1',
                skinColor: '#FFF3D7',
                hairColor: '#1B2C25',
                clothColor: '#1B2C25',
                backgroundColor: '#006D2C',
                mouthColor: '#1B2C25',
            };
        },
        computed: {
            settings () {
                return {
                    background: 'Background1',
                    body: 'Body1',
                    cloth: 'Cloth1',
                    hair: this.selectedHair,
                    eyes: this.selectedEyes,
                    mouth: this.selectedMouth,
                    bodyColor: this.skinColor,
                    hairColor: this.hairColor,
                    clothColor: this.clothColor,
                    backgroundColor: this.backgroundColor,
                    mouthColor: this.mouthColor,
                }
            },
        },
        methods: {
            async onSave () {
                if (!this.settings) {
                    return;
                }

                try {
                    this.saving = true;
                    await this.$store.dispatch('user/' + UPDATE_PROFILE_REQUEST, { avatar: this.settings });
                    this.$toast.success('Avatar byl aktualizován.');
                    this.onClose();
                } catch (e) {
                    this.$toast.error('Při aktualizaci profilu došlo k chybě. Zkuste to později.');
                } finally {
                    this.saving = false;
                }
            },
            onClose () {
                this.$emit('close');
            },
            onSelectEyes (eyes) {
                this.selectedEyes = eyes;
            },
            onSelectHair (hair) {
                this.selectedHair = hair;
            },
            onSelectMouth (mouth) {
                this.selectedMouth = mouth;
            },
        },
        created () {
            this.selectedHair = this.currentAvatar.hair;
            this.selectedEyes = this.currentAvatar.eyes;
            this.selectedMouth = this.currentAvatar.mouth;
            this.skinColor = this.currentAvatar.bodyColor;
            this.hairColor = this.currentAvatar.hairColor;
            this.clothColor = this.currentAvatar.clothColor;
            this.backgroundColor = this.currentAvatar.backgroundColor;
            this.mouthColor = this.currentAvatar.mouthColor;
        },
    }
</script>
